
const digest = 'c00cedb3d0e803df5630eb1c2c44670bcd9005f7155f4e5ea51bdba7167ccce2';
const css = `._container_4iajt_1 {
  position: fixed;
  width: min(100%, 320px);
  top: 48px;
  left: 0px;
  padding: 12px;
  background-color: rgba(255, 255, 255, 0.95);
  border-bottom-right-radius: 16px;
  box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.16),
    0px 0px 36px 0px rgba(0, 0, 0, 0.08);
  z-index: 100;
  transform: translate(-100%, 0px);
}

._open_4iajt_15 {
  transform: translate(0%, 0px);
  transition: transform 0.2s;
}

._inputs_4iajt_20 {
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-auto-rows: 32px;
  align-items: center;
  column-gap: 16px;
}

._colors_4iajt_28 {
  padding: 12px 0;
}

hr {
  grid-column: 1 / span 3;
  height: 1px;
  border: none;
  background-color: gainsboro;
  width: calc(100% + 24px);
  margin-left: -12px;
}

._buttonsRow_4iajt_41 {
  display: flex;
  height: 48px;
  padding-top: 8px;
}

._rowButton_4iajt_47 {
  cursor: pointer;
  flex-grow: 2;
  font-family: 'Recursive', sans-serif;
  border: none;
  background-color: transparent;
  border: 2px solid transparent;
}

._rowButton_4iajt_47:hover {
  color: dodgerblue;
}

._rowButton_4iajt_47:focus {
  outline: none;
  border: 2px solid dodgerblue;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"container":"_container_4iajt_1","open":"_open_4iajt_15","inputs":"_inputs_4iajt_20","colors":"_colors_4iajt_28","buttonsRow":"_buttonsRow_4iajt_41","rowButton":"_rowButton_4iajt_47"};
export { css, digest };
  